"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactHookForm = require("react-hook-form");
var _classnames = _interopRequireDefault(require("classnames"));
var _index = require("../../utils/index");
require("./styles.scss");
var _excluded = ["ref"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CheckNumberField = function CheckNumberField(_ref) {
  var control = _ref.control;
  var refundCheckNumberErrorMessage = 'Invalid check number';
  var refundCheckNumberRules = {
    required: 'The check number is required',
    maxLength: {
      value: 20,
      message: refundCheckNumberErrorMessage
    },
    minLength: {
      value: 1,
      message: refundCheckNumberErrorMessage
    }
  };
  var refundMethod = (0, _reactHookForm.useWatch)({
    control: control,
    name: 'refundMethod',
    defaultValue: ''
  });
  var _useController = (0, _reactHookForm.useController)({
      control: control,
      name: 'refundCheckNumber',
      rules: refundCheckNumberRules,
      defaultValue: '',
      shouldUnregister: true
    }),
    _useController$field = _useController.field,
    ref = _useController$field.ref,
    rest = (0, _objectWithoutProperties2.default)(_useController$field, _excluded),
    error = _useController.fieldState.error;
  (0, _react.useEffect)(function () {
    if (refundMethod === 'ACH') {
      rest.onChange('');
    }
  }, [refundMethod]);
  var refundCheckNumberClasses = (0, _classnames.default)('check-number-input', {
    'check-number-input--error': error
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "check-number-field"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: rest.name,
    "aria-label": "Check Number"
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    step: 10,
    "aria-label": "Check number",
    "aria-invalid": !!error,
    className: refundCheckNumberClasses,
    placeholder: "Check number",
    inputMode: "numeric"
  }, rest, {
    type: "text",
    value: rest.value,
    "data-test-id": "check-number",
    onChange: function onChange(e) {
      var value = (0, _index.sanitizeValues)(e.target.value, _index.REGEX_DIGITS);
      rest.onChange(value);
    }
  })))), error && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: rest.name,
    role: "alert",
    className: "check-number-field--error"
  }, error.message));
};
CheckNumberField.propTypes = {
  control: (0, _propTypes.shape)({}).isRequired
};
var _default = exports.default = CheckNumberField;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/CheckNumberField/styles.scss');